var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"fullscreen":false,"content-class":"force-no-margins-dialog","width":_vm.dialogWidth,"lazy":""},on:{"input":function (val) { return _vm.$emit('update:show', val); }}},[_c('v-fade-transition',[(_vm.show)?_c('v-card',{style:({overflow: 'hidden'})},[_c('div',{style:({height: _vm.dialogHeight + 'px'})},[_c('mini-preview-video-player',{attrs:{"video-url":_vm.previewUrl,"poster-url":_vm.posterUrl,"width":_vm.dialogWidth,"height":_vm.dialogHeight}})],1)]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniPreviewVideoDialog.vue?vue&type=template&id=1f807a12
// module id = 1427
// module chunks = 5